
import { Placement } from '@post-office/placements-frontend/ai-powered-risk-assessment-spotlights';
export default Placement;
